export const copyright = `© ${new Date().getFullYear()} Sorare, SAS. All Rights Reserved.`;
